import React from "react";
import "./style.css";

const Star4_5 = () => {
  return (
    <div className="star_container">
      <img src="images/star.png" />
      <img src="images/star.png" />
      <img src="images/star.png" />
      <img src="images/star.png" />
      <img src="images/half_star.png" />
    </div>
  );
};

export default Star4_5;
